export const metaTags = {
  tr: {
    home: {
      title: "CO2 Neutral - Karbon Nötr Geleceğe Adım Atın",
      description: "CO₂ emisyonlarınızı azaltın, dijital varlıklarınızı nötr hale getirin. 2008'den beri Berlin'de faaliyet gösteren karbon nötr teknoloji çözümleri.",
      keywords: "CO2 nötr, karbon nötr, web sitesi, sürdürülebilirlik, çevre dostu, Berlin, karbon ayak izi, yeşil teknoloji",
      ogTitle: "CO2 Neutral - Karbon Nötr Geleceğe Adım Atın",
      ogDescription: "CO₂ emisyonlarınızı azaltın, dijital varlıklarınızı nötr hale getirin. Sürdürülebilir teknoloji çözümleri.",
      twitterTitle: "CO2 Neutral - Karbon Nötr Geleceğe Adım Atın",
      twitterDescription: "CO₂ emisyonlarınızı azaltın, dijital varlıklarınızı nötr hale getirin.",
      ogLocale: "tr_TR",
      ogUrl: "https://co2neutralpage.com/tr"
    },
    services: {
      title: "CO2 Neutral Hizmetleri - Karbon Nötr Web Çözümleri",
      description: "Web sitenizi karbon nötr hale getirin. CO₂ nötr web hizmetleri, karbon hesaplama, sertifika ve karbon borsası çözümleri.",
      keywords: "CO2 nötr web, karbon hesaplama, karbon sertifikası, yeşil hosting, sürdürülebilir web",
      ogTitle: "CO2 Neutral Hizmetleri - Karbon Nötr Web Çözümleri",
      ogDescription: "Web sitenizi karbon nötr hale getirin. Profesyonel CO₂ nötr çözümler.",
      twitterTitle: "CO2 Neutral Hizmetleri",
      twitterDescription: "Web sitenizi karbon nötr hale getirin.",
      ogLocale: "tr_TR",
      ogUrl: "https://co2neutralpage.com/tr/services"
    },
    contact: {
      title: "İletişim - CO2 Neutral",
      description: "CO2 Neutral ile iletişime geçin. Türkiye, Almanya ve İspanya ofislerimizden size yardımcı olmaktan mutluluk duyarız.",
      keywords: "CO2 neutral iletişim, karbon nötr destek, çevre teknolojisi iletişim",
      ogTitle: "İletişim - CO2 Neutral",
      ogDescription: "CO2 Neutral ile iletişime geçin. Size yardımcı olmaktan mutluluk duyarız.",
      twitterTitle: "İletişim - CO2 Neutral",
      twitterDescription: "CO2 Neutral ile iletişime geçin.",
      ogLocale: "tr_TR",
      ogUrl: "https://co2neutralpage.com/tr/contact"
    },
    certificate: {
      title: "Sertifika Doğrulama - CO2 Neutral",
      description: "CO2 Neutral sertifika doğrulama sistemi. Blockchain destekli güvenli sertifika doğrulama ile karbon nötr sertifikanızı kontrol edin.",
      keywords: "CO2 sertifika doğrulama, karbon nötr sertifika, blockchain doğrulama",
      ogTitle: "Sertifika Doğrulama - CO2 Neutral",
      ogDescription: "Blockchain destekli güvenli sertifika doğrulama sistemi.",
      twitterTitle: "Sertifika Doğrulama - CO2 Neutral",
      twitterDescription: "CO2 Neutral sertifika doğrulama sistemi.",
      ogLocale: "tr_TR",
      ogUrl: "https://co2neutralpage.com/tr/certificate-verification"
    },
    badge: {
      title: "CO2 Neutral Rozeti Ekle - Web Sitenize Karbon Nötr Rozeti",
      description: "Web sitenize özelleştirilebilir CO₂ neutral rozeti ekleyin. Renk, font ve boyut seçenekleriyle sitenize uygun hale getirin.",
      keywords: "CO2 rozeti, karbon nötr rozeti, web sitesi rozeti, çevre dostu rozet",
      ogTitle: "CO2 Neutral Rozeti Ekle",
      ogDescription: "Web sitenize özelleştirilebilir CO₂ neutral rozeti ekleyin.",
      twitterTitle: "CO2 Neutral Rozeti Ekle",
      twitterDescription: "Web sitenize karbon nötr rozeti ekleyin.",
      ogLocale: "tr_TR",
      ogUrl: "https://co2neutralpage.com/tr/add-co2-badge"
    }
  },
  de: {
    home: {
      title: "CO2 Neutral - Schritt in eine CO₂-neutrale Zukunft",
      description: "Reduzieren Sie Ihre CO₂-Emissionen, machen Sie Ihre digitalen Assets neutral. Führende nachhaltige Technologielösungen seit 2008 in Berlin.",
      keywords: "CO2 neutral, kohlenstoffneutral, Website, Nachhaltigkeit, umweltfreundlich, Berlin, CO2-Fußabdruck, grüne Technologie",
      ogTitle: "CO2 Neutral - Schritt in eine CO₂-neutrale Zukunft",
      ogDescription: "Reduzieren Sie Ihre CO₂-Emissionen, machen Sie Ihre digitalen Assets neutral. Nachhaltige Technologielösungen.",
      twitterTitle: "CO2 Neutral - Schritt in eine CO₂-neutrale Zukunft",
      twitterDescription: "Reduzieren Sie Ihre CO₂-Emissionen, machen Sie Ihre digitalen Assets neutral.",
      ogLocale: "de_DE",
      ogUrl: "https://co2neutralpage.com/de"
    },
    services: {
      title: "CO2 Neutral Dienstleistungen - Kohlenstoffneutrale Web-Lösungen",
      description: "Machen Sie Ihre Website kohlenstoffneutral. CO₂-neutrale Web-Dienste, Kohlenstoffberechnung, Zertifizierung und Kohlenstoffbörsen-Lösungen.",
      keywords: "CO2 neutrales Web, Kohlenstoffberechnung, Kohlenstoffzertifizierung, grünes Hosting, nachhaltiges Web",
      ogTitle: "CO2 Neutral Dienstleistungen - Kohlenstoffneutrale Web-Lösungen",
      ogDescription: "Machen Sie Ihre Website kohlenstoffneutral. Professionelle CO₂-neutrale Lösungen.",
      twitterTitle: "CO2 Neutral Dienstleistungen",
      twitterDescription: "Machen Sie Ihre Website kohlenstoffneutral.",
      ogLocale: "de_DE",
      ogUrl: "https://co2neutralpage.com/de/services"
    },
    contact: {
      title: "Kontakt - CO2 Neutral",
      description: "Kontaktieren Sie CO2 Neutral. Wir helfen Ihnen gerne von unseren Büros in Deutschland, der Türkei und Spanien.",
      keywords: "CO2 neutral Kontakt, kohlenstoffneutraler Support, Umwelttechnologie Kontakt",
      ogTitle: "Kontakt - CO2 Neutral",
      ogDescription: "Kontaktieren Sie CO2 Neutral. Wir helfen Ihnen gerne weiter.",
      twitterTitle: "Kontakt - CO2 Neutral",
      twitterDescription: "Kontaktieren Sie CO2 Neutral.",
      ogLocale: "de_DE",
      ogUrl: "https://co2neutralpage.com/de/contact"
    },
    certificate: {
      title: "Zertifikatsverifizierung - CO2 Neutral",
      description: "CO2 Neutral Zertifikatsverifizierungssystem. Sichere Zertifikatsverifizierung mit Blockchain-Technologie zur Überprüfung Ihres kohlenstoffneutralen Zertifikats.",
      keywords: "CO2 Zertifikatsverifizierung, kohlenstoffneutrales Zertifikat, Blockchain-Verifizierung",
      ogTitle: "Zertifikatsverifizierung - CO2 Neutral",
      ogDescription: "Sichere Zertifikatsverifizierung mit Blockchain-Technologie.",
      twitterTitle: "Zertifikatsverifizierung - CO2 Neutral",
      twitterDescription: "CO2 Neutral Zertifikatsverifizierungssystem.",
      ogLocale: "de_DE",
      ogUrl: "https://co2neutralpage.com/de/certificate-verification"
    },
    badge: {
      title: "CO2 Neutral Badge hinzufügen - Kohlenstoffneutrales Badge für Ihre Website",
      description: "Fügen Sie Ihrer Website ein anpassbares CO₂-neutrales Badge hinzu. Passen Sie es mit Farb-, Schrift- und Größenoptionen an Ihre Website an.",
      keywords: "CO2 Badge, kohlenstoffneutrales Badge, Website Badge, umweltfreundliches Badge",
      ogTitle: "CO2 Neutral Badge hinzufügen",
      ogDescription: "Fügen Sie Ihrer Website ein anpassbares CO₂-neutrales Badge hinzu.",
      twitterTitle: "CO2 Neutral Badge hinzufügen",
      twitterDescription: "Fügen Sie Ihrer Website ein kohlenstoffneutrales Badge hinzu.",
      ogLocale: "de_DE",
      ogUrl: "https://co2neutralpage.com/de/add-co2-badge"
    }
  },
  en: {
    home: {
      title: "CO2 Neutral - Step into a CO₂ Neutral Future",
      description: "Reduce your CO₂ emissions, make your digital assets neutral. Leading sustainable technology solutions since 2008 in Berlin.",
      keywords: "CO2 neutral, carbon neutral, website, sustainability, eco-friendly, Berlin, carbon footprint, green technology",
      ogTitle: "CO2 Neutral - Step into a CO₂ Neutral Future",
      ogDescription: "Reduce your CO₂ emissions, make your digital assets neutral. Sustainable technology solutions.",
      twitterTitle: "CO2 Neutral - Step into a CO₂ Neutral Future",
      twitterDescription: "Reduce your CO₂ emissions, make your digital assets neutral.",
      ogLocale: "en_US",
      ogUrl: "https://co2neutralpage.com/en"
    },
    services: {
      title: "CO2 Neutral Services - Carbon Neutral Web Solutions",
      description: "Make your website carbon neutral. CO₂ neutral web services, carbon calculation, certification and carbon exchange solutions.",
      keywords: "CO2 neutral web, carbon calculation, carbon certification, green hosting, sustainable web",
      ogTitle: "CO2 Neutral Services - Carbon Neutral Web Solutions",
      ogDescription: "Make your website carbon neutral. Professional CO₂ neutral solutions.",
      twitterTitle: "CO2 Neutral Services",
      twitterDescription: "Make your website carbon neutral.",
      ogLocale: "en_US",
      ogUrl: "https://co2neutralpage.com/en/services"
    },
    contact: {
      title: "Contact - CO2 Neutral",
      description: "Get in touch with CO2 Neutral. We are happy to help you from our offices in Germany, Turkey and Spain.",
      keywords: "CO2 neutral contact, carbon neutral support, environmental technology contact",
      ogTitle: "Contact - CO2 Neutral",
      ogDescription: "Get in touch with CO2 Neutral. We are happy to help you.",
      twitterTitle: "Contact - CO2 Neutral",
      twitterDescription: "Get in touch with CO2 Neutral.",
      ogLocale: "en_US",
      ogUrl: "https://co2neutralpage.com/en/contact"
    },
    certificate: {
      title: "Certificate Verification - CO2 Neutral",
      description: "CO2 Neutral certificate verification system. Secure certificate verification with blockchain technology to verify your carbon neutral certificate.",
      keywords: "CO2 certificate verification, carbon neutral certificate, blockchain verification",
      ogTitle: "Certificate Verification - CO2 Neutral",
      ogDescription: "Secure certificate verification with blockchain technology.",
      twitterTitle: "Certificate Verification - CO2 Neutral",
      twitterDescription: "CO2 Neutral certificate verification system.",
      ogLocale: "en_US",
      ogUrl: "https://co2neutralpage.com/en/certificate-verification"
    },
    badge: {
      title: "Add CO2 Neutral Badge - Carbon Neutral Badge for Your Website",
      description: "Add a customizable CO₂ neutral badge to your website. Customize it with color, font and size options to match your website.",
      keywords: "CO2 badge, carbon neutral badge, website badge, eco-friendly badge",
      ogTitle: "Add CO2 Neutral Badge",
      ogDescription: "Add a customizable CO₂ neutral badge to your website.",
      twitterTitle: "Add CO2 Neutral Badge",
      twitterDescription: "Add a carbon neutral badge to your website.",
      ogLocale: "en_US",
      ogUrl: "https://co2neutralpage.com/en/add-co2-badge"
    }
  }
};

export const updateMetaTags = (language, page = 'home') => {
  const tags = metaTags[language]?.[page] || metaTags.tr.home;
  
  // Update title
  document.title = tags.title;
  
  // Update meta description
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    document.head.appendChild(metaDescription);
  }
  metaDescription.content = tags.description;
  
  // Update meta keywords
  let metaKeywords = document.querySelector('meta[name="keywords"]');
  if (!metaKeywords) {
    metaKeywords = document.createElement('meta');
    metaKeywords.name = 'keywords';
    document.head.appendChild(metaKeywords);
  }
  metaKeywords.content = tags.keywords;
  
  // Update Open Graph tags
  let ogTitle = document.querySelector('meta[property="og:title"]');
  if (!ogTitle) {
    ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    document.head.appendChild(ogTitle);
  }
  ogTitle.content = tags.ogTitle;
  
  let ogDescription = document.querySelector('meta[property="og:description"]');
  if (!ogDescription) {
    ogDescription = document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    document.head.appendChild(ogDescription);
  }
  ogDescription.content = tags.ogDescription;
  
  // Update Open Graph URL
  let ogUrl = document.querySelector('meta[property="og:url"]');
  if (!ogUrl) {
    ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    document.head.appendChild(ogUrl);
  }
  ogUrl.content = tags.ogUrl;
  
  // Update Open Graph Locale
  let ogLocale = document.querySelector('meta[property="og:locale"]');
  if (!ogLocale) {
    ogLocale = document.createElement('meta');
    ogLocale.setAttribute('property', 'og:locale');
    document.head.appendChild(ogLocale);
  }
  ogLocale.content = tags.ogLocale;
  
  // Update Twitter tags
  let twitterTitle = document.querySelector('meta[property="twitter:title"]');
  if (!twitterTitle) {
    twitterTitle = document.createElement('meta');
    twitterTitle.setAttribute('property', 'twitter:title');
    document.head.appendChild(twitterTitle);
  }
  twitterTitle.content = tags.twitterTitle;
  
  let twitterDescription = document.querySelector('meta[property="twitter:description"]');
  if (!twitterDescription) {
    twitterDescription = document.createElement('meta');
    twitterDescription.setAttribute('property', 'twitter:description');
    document.head.appendChild(twitterDescription);
  }
  twitterDescription.content = tags.twitterDescription;
  
  // Update Twitter URL
  let twitterUrl = document.querySelector('meta[property="twitter:url"]');
  if (!twitterUrl) {
    twitterUrl = document.createElement('meta');
    twitterUrl.setAttribute('property', 'twitter:url');
    document.head.appendChild(twitterUrl);
  }
  twitterUrl.content = tags.ogUrl;
  
  // Update language attribute
  document.documentElement.lang = language;
  
  // Update canonical URL
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = tags.ogUrl;
  
  // Force social media platforms to refresh cache by adding timestamp
  const timestamp = Date.now();
  const ogImage = document.querySelector('meta[property="og:image"]');
  if (ogImage) {
    ogImage.content = `https://co2neutralpage.com/og-image.jpg?v=${timestamp}`;
  }
  
  const twitterImage = document.querySelector('meta[property="twitter:image"]');
  if (twitterImage) {
    twitterImage.content = `https://co2neutralpage.com/og-image.jpg?v=${timestamp}`;
  }
}; 